import { ShipmentWaypointType } from "./shipment-waypoint-type";
import {ShipmentWaypointLine} from "./shipment-waypoint-line.model";
import { Location } from "src/app/location/location.model";

export class ShipmentWaypoint {

    waypointId: number;
    waypointNumber: number;
    location: Location;
    waypointType: ShipmentWaypointType;
    scheduledArrival?: string; // ISO Date string
    actualArrival?: string;   // ISO Date string
    scheduledDeparture?: string;
    actualDeparture?: string;
    status: string;
    remarks?: string;
    lineItems: ShipmentWaypointLine[] = [];

  }
